<cdk-virtual-scroll-viewport
  id="virtualScrollContainer"
  class="list-container list-group v-list toBottom"
  [itemSize]="30"
  [maxBufferPx]="900"
  [minBufferPx]="900">
  <ul class="list-group">
    <span
      *cdkVirtualFor="let item of data$ | async; let i = index; let data"
      [ngClass]="{
        'basic-list-group-item-warning': item.active,
        'basic-list-group-item-striped':
          (config.hasOwnProperty('striped')
            ? config.striped
            : defaultConfig.striped) &&
          i % 2 == 0 &&
          !item.active,
        'basic-list-group-item':
          (!(config.hasOwnProperty('striped')
            ? config.striped
            : defaultConfig.striped) &&
            !item.active) ||
          (item.scrollIndex % 2 !== 0 && !item.active),
      }"
      [ngStyle]="{'min-width': config.minWidth || defaultConfig.minWidth}"
      [id]="'row-' + item[config.rowIdentifier || defaultConfig.rowIdentifier]"
      class="basic-list-row-wrapper">
      <ng-template
        [ngTemplateOutlet]="listItemTemplateRef"
        [ngTemplateOutletContext]="{item: item, index: i}">
      </ng-template>
    </span>
  </ul>
</cdk-virtual-scroll-viewport>
